import { ChevronRightIcon, Flex, Link } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import styles from './expandableNavItem.module.css';

type PositionType = 'first' | 'last' | 'single';

/**
 * @param NavItemObject - An object containing the following properties: position, title, to.
 * @param NavItemObject.position - The position of the expandable nav item in the list.
 * @param NavItemObject.title - The title of the expandable nav item.
 * @param NavItemObject.to - The route that the expandable nav item should navigate a user to on click.
 */
export const ExpandableNavItem = ({
  title,
  to,
  position,
}: {
  position?: PositionType;
  title: string;
  to: string;
}) => {
  return (
    <Link
      className={clsx(styles['link'], {
        [styles['link--first']]: position === 'first' || position === 'single',
        [styles['link--last']]: position === 'last' || position === 'single',
      })}
      to={to}
      variant="minimal"
      typography="body-bold"
    >
      <Flex justifyContent="space-between">
        {title}
        <ChevronRightIcon />
      </Flex>
    </Link>
  );
};
